module.exports = __webpack_public_path__ + "img/2.ff46d931.svg";